<template>
  <div>
    <v-card>
      <v-card-title>Add news</v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-text-field filled label="Title" v-bind:rules="validation.title" v-model="newsData.title"
            @change="onTitleChange($event)"></v-text-field>
          <redactor v-model="newsData.body"></redactor>
          <br>
          <v-autocomplete filled required autocomplete="off" label="Select Category" v-model="newsData.category_id"
            item-text="name" :rules="validation.category" item-value="id" v-bind:items="category"></v-autocomplete>
          <v-card class="my-2">
            <v-card-title>
              Add tag (optional)
            </v-card-title>
            <v-card-text>
              <v-combobox v-model="newsData.content_tag" chips outlined clearable label="Add tag and press enter"
                multiple>
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip v-bind="attrs" :input-value="selected" close aria-multiline="true" @click="select"
                    @click:close="removeContentTag(item)">
                    <strong>{{ item }}</strong>&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-card-text>
          </v-card>
          <v-card tile>
            <v-card-title>
              Images
            </v-card-title>
            <v-card-text>
              <v-file-input filled label="Photo" v-model="imageData" accept="image/*" prepend-icon="mdi-camera" multiple
                hide-details @change="imageInputChangedCallback">
                <template v-slot:selection>
                </template>
              </v-file-input>

              <div v-if="selectedImages !== null && Array.isArray(selectedImages) && selectedImages.length > 0">
                <file-images :images="selectedImages" @delete_success="offlineImageDeleteCallback" />
              </div>
              <v-card-subtitle v-else>No image selected</v-card-subtitle>
            </v-card-text>
          </v-card>

          <br>
          <v-file-input filled label="Body Image" accept="image/*" prepend-icon="mdi-image-album"
            v-model="newsData.body_image" show-size counter></v-file-input>
          <v-text-field label="Select publish date" filled clearable readonly :rules="validation.publishDate"
            v-model="formattedDate" @click:clear="dateClearCallback" prepend-icon="mdi-calendar"
            @click="showDatePicker"></v-text-field>
          <v-checkbox label="Check for headline" v-model="newsData.is_headline" />
          <v-checkbox label="For Subscriber only" v-model="newsData.is_for_subscriber" />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>

        <v-btn tile color="primary" class="mx-2" v-on:click="submit" :disabled="!isValid"
          v-bind:loading="loading">Submit</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
    <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog"
      @close="showDatePickerDialog = false"></DatePickerDialog>
  </div>
</template>
<script>
import postApi from '@/api/postApi'
import snackbar from '@/utils/snackbar'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import commonUtils from '@/utils/commonUtils'
import redactor from '@/components/Redactor.vue'

export default {
  components: {
    DatePickerDialog,
    'file-images': () => import('@/components/ImagesFromFiles'),
    redactor
  },
  props: {
    title: {
      type: String,
      default: 'Add News'
    }
  },
  mounted () {
    this.init()
  },
  computed: {

  },
  data () {
    return {
      isValid: null,
      loading: false,
      category: null,
      imageData: null,
      formattedDate: null,
      showDatePickerDialog: false,
      selectedImages: [],

      newsData: {
        title: null,
        body: null,
        body_image: null,
        is_headline: null,
        publish_date: null,
        images: [],
        is_for_subscriber: null,
        category_id: null,
        content_tag: null
      },
      validation: {
        title: [(v) => !!v || 'Please enter title'],
        category: [(v) => !!v || 'Please select category'],
        publishDate: [(v) => !!v || 'Please enter publish date']
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.loading && (this.newsData.is_headline || this.newsData.is_for_subscriber || this.newsData.body_image || this.selectedImages || this.newsData.title || this.newsData.body || this.newsData.category_id || this.newsData.publish_date)) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  watch: {
    'newsData.title': function (newVal, oldVal) {
      this.$log.info('title ', [newVal, oldVal])
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.newsData.title = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.newsData.title = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    }
  },
  methods: {
    removeContentTag (item) {
      this.newsData.content_tag.splice(
        this.newsData.content_tag.indexOf(item),
        1
      )
    },
    async init () {
      const response = await postApi.getCategories()
      if (response.data !== undefined) {
        this.category = response.data
      }
    },
    offlineImageDeleteCallback (data) {
    // clear file input when image is deleted so that the same image can be added again if deleted by mistake
      this.imageData = null
      const index = this.selectedImages.indexOf(data.file)
      if (index !== undefined && index !== null) {
        if (index > -1) {
          this.selectedImages.splice(index, 1)
        }
      }
    },
    async imageInputChangedCallback (file) {
      if (file == null) {
      // this.selectedImages = []
        return
      }

      file.forEach(element => {
        this.newsData.images.push(element)
        const reader = new FileReader()
        reader.onload = e => (this.selectedImages.push(e.target.result))
        reader.readAsDataURL(element)
      })
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.newsData.publish_date = null
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.newsData.publish_date = dateUtils.parseDate(data)
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    async submit () {
      if (this.newsData.body === '') {
        snackbar.show('Please enter body', 'error')
        return
      }
      this.loading = true
      try {
        if (this.newsData.content_tag) {
          this.newsData.tag = this.newsData.content_tag.join(' § ') // option key + 5
        }
        this.$log.info('insert new params', [this.newsData])
        const response = await postApi.insertNews(this.newsData)
        if (response.data !== undefined) {
          if (response.data.id !== undefined) {
            this.newsData.title = ''
            this.newsData.body = ''
            this.newsData.images = []
            this.newsData.is_for_subscriber = null
            this.newsData.category_id = null
            this.$refs.form.reset()
            snackbar.show('News added successfully', 'success')

            window.publish_date = this.newsData.publish_date
            this.$router.push({ path: '/news', replace: true })
          }
        }
      } finally {
        this.loading = false
      }
    },

    onTitleChange (newVal, oldVal) {
      this.$log.info('Ontitle change', newVal, oldVal)
      this.newsData.title = commonUtils.parseStringForTri(newVal)
    }
  }
}
</script>

<style>
.ql-editor {
  min-height: 350px;
  font-size: 15px;
}
</style>
